(() => {
  const sections = document.querySelectorAll('[data-elc-app-download]');
  if (!sections.length) return;

  const isStoreUrl = (url, platform) => {
    try {
      const parsed = new URL(url);
      return parsed.protocol === 'https:' && parsed.hostname === (platform === 'ios' ? 'apps.apple.com' : 'play.google.com');
    } catch {
      return false;
    }
  };

  const device = () => {
    const ua = navigator.userAgent || '';
    const platform = navigator.userAgentData?.platform || '';
    if (/android/i.test(platform) || /android/i.test(ua)) return 'android';
    if (/ios|ipad|iphone/i.test(platform) || /iPad|iPhone|iPod/i.test(ua)) return 'ios';
    if (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return 'ios';
    return null;
  };

  for (const section of sections) {
    if (section.dataset.elcAppDownloadInitialized === 'true') continue;
    section.dataset.elcAppDownloadInitialized = 'true';
    const storeUrls = {
      android: section.dataset.googlePlayUrl || '',
      ios: section.dataset.appleAppStoreUrl || ''
    };
    const params = new URLSearchParams(window.location.search);
    const explicitPreview = params.get('preview') === '1' || params.has('preview_theme_id') || params.get('manual') === '1' || params.get('redirect') === '0';
    const inEditor = section.dataset.designMode === 'true' || window.Shopify?.designMode === true;
    const robot = /bot|crawl|spider|headless|lighthouse|pagespeed|google-inspectiontool/i.test(navigator.userAgent || '');
    const destination = device();

    for (const link of section.querySelectorAll('[data-elc-store-link]')) {
      const platform = link.getAttribute('data-elc-store-link');
      link.addEventListener('click', () => {
        if (Array.isArray(window.dataLayer)) {
          window.dataLayer.push({event: 'elc_app_store_click', platform: platform});
        }
      });
    }

    if (section.dataset.autoRedirect !== 'true' || explicitPreview || inEditor || robot || !destination) continue;
    const target = storeUrls[destination];
    if (!isStoreUrl(target, destination)) continue;

    const status = section.querySelector('[data-elc-redirect-status]');
    if (status) status.hidden = false;
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({event: 'elc_app_store_redirect', platform: destination});
    }
    window.setTimeout(() => window.location.replace(target), 280);
  }
})();